import {ICatalogo} from "./ICatalogo";

interface ISucursal {
    id: number
    nombre: string
    ocurreAreaServicioId: string
    pais: ICatalogo
    estado: ICatalogo
    ciudad: ICatalogo
    horaCorte:any,
    horaCorteSabado:any
}

export class Sucursal {
    direccion: string;

    constructor(props: ISucursal) {
        Object.assign(this, props);
        this.direccion = `${this.ciudad.nombre} ${this.estado.nombre}`
    }
}

export interface Sucursal extends ISucursal {
}
